export default __webpack_public_path__ + "static/Logo_dark-1da16d8c9b828ca7e309d20a3d9d6d0b.svg";